import { formatRatingAverage } from 'helpers/formatters'

const getWinners = alternatives => {
  const winners = {
    rating_ease: { value: -Infinity, slug: '' },
    rating_features: { value: -Infinity, slug: '' },
    rating_support: { value: -Infinity, slug: '' },
    rating_value: { value: -Infinity, slug: '' },
  }

  const counts = {
    rating_ease: 0,
    rating_features: 0,
    rating_support: 0,
    rating_value: 0,
  }

  alternatives.forEach(alternative => {
    const data = alternative.reviews.by_field

    for (const key in data) {
      if (winners[key]) {
        const dataFormattedValue = formatRatingAverage(data[key])
        // If the current alternative has a higher value than the current winner, update the winner & count
        if (dataFormattedValue > winners[key].value) {
          winners[key] = { value: dataFormattedValue, slug: alternative.slug }
          counts[key] = 1
          // If the current alternative has the same value as the current winner, increment the winners count
        } else if (dataFormattedValue === winners[key].value) {
          counts[key] += 1
        }
      }
    }
  })
  for (const key in winners) {
    // If there are multiple winners, set the value to null
    if (counts[key] > 1) {
      winners[key] = { value: null, slug: '' }
    }
  }

  return winners
}

export { getWinners }
